<template>
    <div style="overflow: hidden; width: 100%; height:  calc(100vh - 80px);">

        <vxe-toolbar :buttons="toolbarButtons" @button-click="buttonClickEvent" ref="toolbarRef" custom ></vxe-toolbar>
        <vxe-table border ref="tableRef" :row-config="{ isCurrent: true }" :custom-config="{immediate:true}" :data="tableData"
            class="table-style" height="auto" align="center">
            <vxe-column type="seq" width="70"></vxe-column>
            <vxe-column sortable field="name" title="姓名">
                <template #default="{ row }">
                    <span v-copy.dblclick>{{ row.name}}</span>
                </template>
            </vxe-column>
            <!-- <vxe-column sortable field="name" title="姓名"></vxe-column> -->
            <vxe-column field="address" title="地址"></vxe-column>
            <vxe-column field="phone" title="电话"></vxe-column>
            <vxe-column field="pwd" title="密码"></vxe-column>
            <vxe-column field="company" title="公司"></vxe-column>
            <vxe-column field="area" title="区域"></vxe-column>
            <vxe-column title="操作" width="250">
                <template #default="{ row }">
                    <vxe-button mode="text" status="success" icon="vxe-icon-edit"
                        @click="editEvent(row)">编辑</vxe-button>
                    <vxe-button mode="text" status="warning" icon="vxe-icon-edit"
                        @click="assignPer(row)">分配角色</vxe-button>
                </template>
            </vxe-column>
        </vxe-table>

        <el-dialog title="新增&修改用户" :visible.sync="showPopup" :close-on-click-modal="false" destroy-on-close width="50%"
            :before-close="handleClose">
            <el-form ref="formRef" :model="formData" label-width="80px">
                <el-form-item required label="姓名">
                    <el-input v-model="formData.name" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item label="地址">
                    <el-input v-model="formData.address" placeholder="请输入地址"></el-input>
                </el-form-item>
                <el-form-item label="电话">
                    <el-input v-model.trim="formData.phone" placeholder="请输入电话"></el-input>
                </el-form-item>
                <el-form-item required label="密码">
                    <el-input v-model.trim="formData.pwd" placeholder="请输入密码"></el-input>
                </el-form-item>
                <el-form-item label="公司">
                    <el-input v-model="formData.company" placeholder="请输入公司"></el-input>
                </el-form-item>
                <el-form-item label="区域">
                    <el-input v-model="formData.area" placeholder="请输入区域"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showPopup = false;">取 消</el-button>
                <el-button type="primary" @click="addSave">确 定</el-button>
            </span>
        </el-dialog>
        <vxe-modal v-model="showauth" title="分配权限" :width="1000" esc-closable>
            <vxe-checkbox-group v-model="hobbiesList" style="display: flex;justify-content: center;">
                <vxe-checkbox v-for="item in options" :label="item.label" :content="item.label"></vxe-checkbox>
            </vxe-checkbox-group>
            <div style="display: flex;justify-content: center;margin-top: 1vh;">
                <vxe-button status="primary" content="保存确认" @click="saveAndEdit()"></vxe-button>
            </div>
        </vxe-modal>


    </div>
</template>

<script>
export default {
    name: 'usermanager',
    data() {
        const toolbarButtons = [
            { name: '新增', code: 'add', status: 'primary' },
            { name: '删除', code: 'del', status: 'error' },
            // { name: '保存', code: 'save', status: 'success' }
        ]
        // const hobbiesItemRender = {
        //     options: [
        //         { label: '爬山', value: '1' },
        //         { label: '干架', value: '2' },
        //         { label: '干饭', value: '3' },
        //         { label: '游泳', value: '4' },
        //         { label: '跑步', value: '5' }
        //     ]
        // }
        return {
            username: '',
            // hobbiesItemRender,
            // hobbiesItemRender: {
            options: [],
            // },
            // formData: {
            hobbiesList: [],
            // },
            authnum: [],
            showauth: false,
            formData: {
                name: '',
                address: '',
                phone: '',
                pwd: '',
                company: '',
                area: '',
                id: ''
            },
            showPopup: false,
            tableData: [],
            toolbarButtons,
            iconList: [],
            userChooseIcon: '',
            chooseIcons: '',
        }
    },
    created() {
        this.getListData();
        // this.iconList = elementIcons
    },
    mounted() {
        const $table = this.$refs.tableRef
        const $toolbar = this.$refs.toolbarRef
        if ($table && $toolbar) {
            $table.connect($toolbar)
        }
    },
    methods: {
        // 保存更新
        saveAndEdit() {
            this.$api.insRelations( this.username, this.hobbiesList ).then(res =>{
                this.$message.success('保存更新成功');
                this.getListData();
            })
            this.showauth = false;
        },
        assignPer(row) {
            this.username = row.name;
            this.$api.getRoleByUser(row.name).then(res => {
                const obj = res;
                this.options = [];
                this.hobbiesList = []
                obj.forEach((item, index) => {
                    this.options.push({
                        label: item.roleName,
                        value: item.id
                    });
                    if (item.selected) {
                        this.hobbiesList.push(item.roleName);
                    }
                });
                this.showauth = true;
            })
        },
        editEvent(row) {
            this.showPopup = true;
            this.formData = row;
        },
        addSave() {
            if (this.formData.name === '' || this.formData.pwd === '') {
                this.$message.error('请填写必填项');
            } else {
                this.$api.insUser( this.formData ).then(res =>{
                    this.$message.success('添加成功');
                    this.getListData();
                    this.handleClose();
                })
            }
        },
        setIcon(icon) {
            this.userChooseIcon = icon;//将i的样式设为选中的样式el-icon-xxx
            this.chooseIcons = icon;
            this.formData.clazz = icon;
        },
        getListData() {
            this.$api.getUserList( ).then(res =>{
                this.tableData = res;
            })
        },
        buttonClickEvent({ code }) {
            if (code === 'add') {
                this.showPopup = true;
            }
        },
        handleClose() {
            this.showPopup = false;
            this.formData.id = '';
            this.options = [];
            // this.formData.name = '';
            // this.formData.address = '';
            // this.formData.phone = '';
            // this.formData.pwd = '';
            // this.formData.company = '';
            // this.formData.area = '';
            // location.reload();
        },
    },
}
</script>

<style lang="css" scoped>
.chooseIcons {
    width: 100%;

}


.iconList {
    width: 30vw;
    height: 300px;
    overflow-y: scroll;
    overflow-x: hidden;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
}

.icon {
    display: inline-block;
    width: 60px;
    height: 45px;
    color: #000000;
    font-size: 20px;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    cursor: pointer;
    text-align: center;
    line-height: 45px;
    margin: 5px;

}

.icon:hover {
    color: red;
    border-color: red;
}

.iconDiv {
    width: 100%;
    height: 50%;

    display: flex;
    flex-direction: row;
    align-items: center;
}

.iconName {
    width: 100%;
    height: 45px;
    text-align: center;
    border-color: #C0C4CC;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
}

::v-deep .table-style .vxe-table .vxe-cell {
    padding: 0 !important;
    line-height: 1.3vh;
}

::v-deep .el-form-item__label-wrap {
    margin-left: 0px !important;
}

::v-deep .table-style .vxe-body--column {
    padding: 0 !important;
}
</style>